import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../../configs/AppConfig";
import {AUTH_TIPE} from "../../constants/AuthConstant";

const  tarifUpahService = {}

tarifUpahService.data = function (token,data='') {
    return fetch({
        url: '/ref/tarif_upah/data',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

tarifUpahService.show = function (token,data='') {
    return fetch({
        url: '/ref/tarif_upah/show',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

tarifUpahService.data_import = function (token,data) {
    return fetch({
        url: '/ref/tarif_upah/data_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

tarifUpahService.empty_import = function (token,data) {
    return fetch({
        url: '/ref/tarif_upah/empty_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

tarifUpahService.save_import = function (token,data) {
    return fetch({
        url: '/ref/tarif_upah/save_import',
        method: 'post',
        data: data,
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE),
        }
    })
}

export default tarifUpahService;
